module.exports = __webpack_public_path__ + "img/apm-mastercard.028ca341.svg";